export const useCopy = () => {
  const { showToast } = useToasts()

  const copy = async (value: string) => {
    try {
      await textCopy(value)
      showToast({
        message: 'Copied to clipboard.',
        status: 'SUCCESS',
      })
    } catch (error) {
      if (error instanceof Error) {
        showToast({
          message: 'Failed to save to clipboard. Please try again.',
          status: 'ERROR',
        })
      }
    }
  }
  
  return { copy }
}